((global) => {

  /**
  * Боковая панель настроек.
  *
  * @class WebAccess.components.SettingsPanel
  * @extends WA.CMP.SidePanel
  * @since 5.8.3.9000
  */
  class SettingsPanel extends WA.CMP.SidePanel {
    constructor() {
      super();

      this.headerString = L('SETTINGS');
      this.initiator = '.settingsAboutIco';
      this.settingsElementSelectors = ['.settings-block-name', 'h3', 'h4'];
    };

    /**
     * Отображает боковую панель.
	   * @function WebAccess.components.SettingsPanel.render
     * */
    render() {
      super.render();

      WA.SRV.request('api/UserSettings.asmx/getSettings', { 'componentName': '' }).done(result => {
        $('#sidepanel-body').append(`<div id="filter-settings-wrapper">
                <div class="icon filter"><svg><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#filterOff-16"></use></svg></div>
                <input type="filter" id="filter-settings" placeholder="${L('SETTINGS_PANEL_FILTER')}">
                <div class="icon clear"><svg><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#close-delete-16"></use></svg></div>
               </div>`);
        $('#sidepanel-body').append(`<div class="Empty object-list_empty-wide hidden">
                <div class="container-watermark">
                  <div class="container-watermark__img container-watermark__img_empty-filter"></div>
                  <div class="container-watermark__label">${L('EMPTY_WITH_FILTER')}</div>
                </div>
              </div>`);
        $('#filter-settings')
          .bind('focus', e => { this._filterFocus(e); })
          .bind('blur', e => {
            this._filterFocus(e);
            if (e.target.value !== '') {
              $('#sidepanel-body .icon.clear').show();
            } else {
              $('#sidepanel-body .icon.clear').hide();
            }
          })
          .bind('input', e => { this._filterSettings(e) })
          .bind('change', e => { this._filterSettings(e) });

        $('#sidepanel-body .icon.clear').bind('click', e => {
          let filterInput = $('#filter-settings');
          filterInput.val('');
          filterInput[0].focus();
          filterInput.trigger('change');
          event.stopPropagation();
          event.preventDefault();
        });

        $('#sidepanel-body').append(`<div id="settings-body"></div>`);

        $('#settings-body').append(result.html);

        if (result.initJs) {
          eval(result.initJs);
        }

        // Инициализация настроек.
        Core.settings.
          initPreviewSettings().
          initColoringRecordsSettings().
          initAutoCleaningSettings().
          initAgentControls().
          initDocDefaultAction().
          initManagedFoldersSettings().
          initDocumentVersionsSettings();
      }).fail(() => {
        ShowError(L('SETTINGS_PANEL_SHOW_ERROR_MESSAGE'));
      });

      return this;
    };

    /**
     * Перерисовывает блок с настройками документов.
     * */
    renderDocumentTab() {
      WA.SRV.request('api/UserSettings.asmx/getSettings', { 'componentName': 'DocumentsAndFolders' }).done(result => {
        $('.settings-block .stat_OpenDocumentSettings').closest('.settings-block').replaceWith(result.html);
        // Инициализация переменных заполненных на сервере.
        if (result.initJs) {
          eval(result.initJs);
        }
        // Инициализация необходимых настроек.
        Core.settings.
          initPreviewSettings().
          initDocDefaultAction().
          initManagedFoldersSettings().
          initDocumentVersionsSettings();
      });
    }

    /**
    * Перерисовывает блок с настройками автоочистки.
    * */
    renderAutoCleaningFoldersTab() {
      WA.SRV.request('api/UserSettings.asmx/getSettings', { 'componentName': 'Autocleaning' }).done(result => {
        $('.settings-block .stat_AutoCleaning').closest('.settings-block').replaceWith(result.html);
        // Инициализация переменных заполненных на сервере.
        if (result.initJs) {
          eval(result.initJs);
        }
        // Инициализация необходимых настроек.
        Core.settings.initAutoCleaningSettings();
      });
    }

    /**
     * Обрабатывает клик по строке фильтрации.
     * @param {any} event Событие.
     */
    _filterFocus(event) {
      event.target.parentElement.classList.toggle('active');
    }

    /**
     * Выполняет поиск по настройкам.
     * @param {any} event Событие.
     */
    _filterSettings(event) {
      const minFilterTextLength = 2;
      const filterText = event.target.value.toLowerCase();

      if (!event.target.parentElement.classList.contains('active')) {
        event.target.parentElement.classList.add('active');
      }

      this._removeAllSettingsPanelFilter();
      if (filterText.length >= minFilterTextLength) {
        const isFoundAnySettings = this._panelSettingsFilter(filterText, $('#settings-body'), false);
        if (!isFoundAnySettings) {
          $('#sidepanel-body .Empty').show();
        }
      }
    }

    /**
     * Очищает фильтры панели настроек.
     * */
    _removeAllSettingsPanelFilter() {
      const emptyFilterWatermark = $('#sidepanel-body .Empty');
      if (!emptyFilterWatermark.is(":hidden")) {
        emptyFilterWatermark.hide();
        $('#settings-body').show();
      }
      this.settingsElementSelectors.forEach(value => {
        $(`#settings-body ${value}`).parent().show();
      });
    }

    /**
     * Накладывает фильтр на панель настроек.
     * @param {string} filterText Строка поиска.
     * @param {obj} parentElement Элемент на который накладывается фильтр.
     * @param {number} iterator Итератор элементов.
     */
    _panelSettingsFilter(filterText, parentElement, iterator = 0) {
      let isNeedShowCurrentElement = false;
      let childElementsVisibility = [];
      const isLastSelector = this.settingsElementSelectors.length - 1 <= iterator;

      const jSettingsElements = parentElement.find(this.settingsElementSelectors[iterator++]);
      if (jSettingsElements.length) {
        jSettingsElements.each((i, element) => {
          let jElement = $(element);

          isNeedShowCurrentElement = element.innerText.toLowerCase().indexOf(filterText) >= 0;

          if (!isLastSelector && !isNeedShowCurrentElement) {
            isNeedShowCurrentElement = this._panelSettingsFilter(filterText, jElement.parent(), iterator);
          }

          childElementsVisibility.push(isNeedShowCurrentElement);

          if (isNeedShowCurrentElement) {
            jElement.parent().show();
          } else {
            jElement.parent().hide();
          }
        });
        if (childElementsVisibility.length > 0) {
          isNeedShowCurrentElement = childElementsVisibility.includes(true);
          if (isNeedShowCurrentElement) {
            parentElement.show();
          } else {
            parentElement.hide();
          }
        }
      } else if (!isLastSelector) {
        isNeedShowCurrentElement = this._panelSettingsFilter(filterText, parentElement, iterator);
      }
      return isNeedShowCurrentElement;
    }

  }

  global.SettingsPanel = new SettingsPanel();
})(window.WebAccess.components);